import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import MarketplacePage from "@/pages/marketplace/page";
import UploadPage from "@/pages/upload/page";
import RecruitmentPage from "@/pages/recruitment/page";
import SocialPage from "@/pages/social/page";
import InfluencerPage from "@/pages/influencer/page";
import OverseasPage from "@/pages/overseas/page";
import AuthPage from "@/pages/auth/page";
import DashboardPage from "@/pages/dashboard/page";
import ProductDetailPage from "@/pages/product/page";
import MembershipPage from "@/pages/membership/page";
import FactoryPage from "@/pages/factory/page";
import WholesalePage from "@/pages/wholesale/page";
import CartPage from "@/pages/cart/page";
import ReferralsPage from "@/pages/referrals/page";
import BuyerRequirementsPage from "@/pages/buyer-requirements/page";
import FactoryDashboardPage from "@/pages/factory-dashboard/page";
import USAShopPage from "@/pages/usa-shop/page";
import InfantDonationPage from "@/pages/infant-donation/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/marketplace", element: <MarketplacePage /> },
  { path: "/product/:id", element: <ProductDetailPage /> },
  { path: "/upload", element: <UploadPage /> },
  { path: "/recruitment", element: <RecruitmentPage /> },
  { path: "/social", element: <SocialPage /> },
  { path: "/influencer", element: <InfluencerPage /> },
  { path: "/overseas", element: <OverseasPage /> },
  { path: "/membership", element: <MembershipPage /> },
  { path: "/factory/:id", element: <FactoryPage /> },
  { path: "/wholesale", element: <WholesalePage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/referrals", element: <ReferralsPage /> },
  { path: "/buyer-requirements", element: <BuyerRequirementsPage /> },
  { path: "/auth", element: <AuthPage /> },
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/factory-dashboard", element: <FactoryDashboardPage /> },
  { path: "/usa-shop", element: <USAShopPage /> },
  { path: "/infant-donation", element: <InfantDonationPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
